import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonsService } from '@modules/core/services';
import { RadioOptionsEnum } from '@modules/core/enums';
import { IconedRadioOption } from '@modules/core/interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'pub-iconed-radio',
  templateUrl: './iconed-radio.component.html',
  styleUrls: ['./iconed-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IconedRadioComponent,
      multi: true,
    },
  ],
})
export class IconedRadioComponent implements ControlValueAccessor, OnInit {
  @Input({
    required: true,
  })
  optionsType!: RadioOptionsEnum;
  @Input() disabled = false;
  public options!: Observable<IconedRadioOption[]> | Observable<[]>;

  constructor(private radioButtonsService: RadioButtonsService) {}

  ngOnInit(): void {
    this.options = this.radioButtonsService.generateIconedRadioOptions(this.optionsType);
  }

  private innerValue = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  onChange = (v: string) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  onTouched = (v: string) => {};

  registerOnChange(fn: never): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }

  writeValue(v: string): void {
    if (v !== this.value) {
      this.value = v;
    }
  }

  set value(v: string) {
    this.innerValue = v;
    this.onChange(v);
    this.onTouched(v);
  }

  get value(): string {
    return this.innerValue;
  }
}
